if (!customElements.get('ingredients-modal')) {
  customElements.define(
    'ingredients-modal',
    class IngredientsModal extends ModalDialog {
      show(opener) {
        super.show(opener);
        this.initSwiper();
      }

      initSwiper() {
        // Init on first open, never on page load: Swiper measures slide widths, and a
        // modal that is still display:none measures as zero.
        if (this.swiper) {
          this.swiper.update();
          return;
        }

        const container = this.querySelector('.swiper');
        if (!container) return;

        // A single-slide product needs no carousel at all — leave it as a plain image.
        if (container.querySelectorAll('.swiper-slide').length < 2) return;
        if (typeof Swiper === 'undefined') return;

        this.swiper = new Swiper(container, {
          slidesPerView: 1,
          spaceBetween: 24,
          loop: false,
          autoHeight: true,
          keyboard: { enabled: true },
          navigation: {
            nextEl: container.querySelector('.swiper-button-next'),
            prevEl: container.querySelector('.swiper-button-prev'),
          },
          pagination: {
            el: container.querySelector('.swiper-pagination'),
            clickable: true,
          },
        });
      }
    }
  );
}
